import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "weighted-term-cloud",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "Terms sized by weight, with the weight always written next to the term. Falls back to a ranked list with bars when narrow.",
    domain: "ott-piracy",
    visual: "Term cloud",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content" },
  defaultLayoutClassName: "col-span-12 xl:col-span-8",
};
